"use client";

import { Route } from "react-router-dom";

interface LocalizedRouteConfig {
  path: string;
  element: React.ReactElement;
}

/**
 * Utility function that creates route elements for all language variations
 * Returns an array of Route elements that can be spread into Routes
 */
export function createLocalizedRoutes({ path, element }: LocalizedRouteConfig) {
  return [
    // Default route (English, no prefix)
    <Route key={`en-${path}`} path={path} element={element} />,

    // Swedish route (/se prefix)
    <Route
      key={`sv-${path}`}
      path={path === '/' ? '/se' : `/se${path}`}
      element={element}
    />,

    // Spanish route (/es prefix)
    <Route
      key={`es-${path}`}
      path={path === '/' ? '/es' : `/es${path}`}
      element={element}
    />
  ];
}

// Legacy component for backwards compatibility - but use createLocalizedRoutes instead
export function LocalizedRoute({ path, element }: LocalizedRouteConfig) {
  return <>{createLocalizedRoutes({ path, element })}</>;
}